import { useEffect, useRef, useState } from 'react'
import Analytics, { AnalyticsEvent } from '@utils/analytics'
import { useAuth } from '@contexts/Auth'
import routes from '@configs/api'

const useAnalytics = () => {
  const { user } = useAuth()
  const [isAnalyticsReady, setIsAnalyticsReady] = useState(false)
  const analyticsRef = useRef<Analytics | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const initialize = async () => {
    setIsLoading(true)
    analyticsRef.current = await Analytics.initialize({
      endpoint: routes.ANALYTICS + '/events',
      user: user?._id,
    })
    setIsAnalyticsReady(true)
    setIsLoading(false)
  }

  useEffect(() => {
    if (user?._id) {
      if (!analyticsRef.current && !isLoading) {
        initialize()
      }
    }
  }, [user?._id])

  const captureEvent = (
    eventType: AnalyticsEvent['eventType'],
    eventData: AnalyticsEvent['eventData'],
    priority: 1 | 2 | 3 = 3
  ) => {
    if (analyticsRef.current && isAnalyticsReady) {
      analyticsRef.current.captureEvent(eventType, eventData, priority)
    }
  }

  const flustEvents = () => {
    if (analyticsRef.current) {
      analyticsRef.current.captureEvent(undefined, undefined, 1)
    }
  }

  return {
    isAnalyticsReady,
    captureEvent,
    events: analyticsRef.current?.events,
    flustEvents,
  }
}

export default useAnalytics
